import React, {useState} from 'react';
import PopUp from '../../components/PopUp';
import {TextInput} from '@mantine/core';
import { ModelPopUpProps, ModelsRowType } from '../../types/models';



const ModelsPopUp = ({opened, close, title, onSave}:ModelPopUpProps)=>{
      const [inputValue, setInputValue] = useState<string>('');
      const [inputError, setInputError] = useState<string>('');
      const handleInputChange = (value:string) => {
        setInputValue(value);

        if (!/^[a-zA-Z0-9]*$/.test(value)) {
            setInputError('Only numeric characters allowed.');
        } else {
            setInputError('');
        }
    };

    return(
        <PopUp opened={opened} close={close} title={title} onSave={()=>onSave({ id: undefined, name: inputValue })} >
            <TextInput label="Name" value={inputValue} onChange={(event) => handleInputChange(event.currentTarget.value)} error={inputError}  />      
        </PopUp>        
    )
}

export default ModelsPopUp